import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";
import Plyr from "plyr";
import "plyr/dist/plyr.css";


export default function View({ uuid }) {

  const appContext = useContext(AppContext);
  const videoRef = useRef(null);

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ data, setData ] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([
      getData(),
    ])
    setReady(true);
  }

  async function getData() {
    await callApi('get-project-data', { uuid }).then((response) => {
      if(response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    })
  }

  useEffect(() => {
    init();
  }, []);

  /* Initialize Plyr once data is ready */
  useEffect(() => {
    if (ready && data && videoRef.current) {
      new Plyr(videoRef.current, {
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          'fullscreen'
        ],
      });
    }
  }, [ready, data]);

  if (ready && data) {
    return (
      <div className="container mt-4 mb-5">

        <div className="row justify-content-center">

          <div className="col-lg-10">

            {/* Video Card */}
            <div
              className="mb-4"
              style={{
                borderRadius: "14px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                background: "#000"
              }}
            >
              <video
                ref={videoRef}
                className="plyr-react plyr"
                playsInline
              >
                <source
                  src={CDN_URL + data.videoFile}
                  type="video/mp4"
                />
              </video>
            </div>

            {/* Meta */}
            <div className="d-flex justify-content-end mb-2">
              <span className="text-muted" style={{ fontSize: "14px" }}>
                {formatDate(data.dateCreated)}
              </span>
            </div>

            <hr />

            {/* Title */}
            <h4
              className="font-semi-bold mb-3"
              style={{
                fontSize: "26px",
                lineHeight: "1.4"
              }}
            >
              {data.title}
            </h4>

            {/* Body */}
            <div
              style={{
                fontSize: "16px",
                lineHeight: "1.8",
                color: "#444"
              }}
              dangerouslySetInnerHTML={{ __html: data.body }}
            />

          </div>

        </div>

      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
